module.exports = __webpack_public_path__ + "static/media/education_map.3bc7e1e3.svg";